import { updateObject } from "../../helpers/index";
import * as aTypes from "../actions/actionTypes";
import { Auth } from "aws-amplify";

// const initialState = null;
const initialState = {
  activeUser: null,
  session: null,
  accessToken: null,
  idToken: null,
  refreshToken: null,
  loadingSession: true
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case aTypes.SESSION_LOGOUT:
      return initLogout(state, action);
    case aTypes.SESSION_SET_ACTIVE:
      return initSessionActive(state, action);
    // case aTypes.SESSION_INIT_ACTIVE:
    //   return initSessionActive(state, action);
    case aTypes.SESSION_SET_ACTIVE_USER:
      return initActiveUser(state, action);
    case aTypes.SESSION_RESET:
      return resetSession(state, action);
    case aTypes.SESSION_SYSTEM_LOAD:
       return {
        ...state,
        loadingSession: action.payload,
      };
    case aTypes.SESSION_UPDATE_MY_USER:
      return updateMyUser(state, action);
    // case aTypes.SESSION_INIT_PUBLIC:
    default:
      return state;
  }
};

// =========== LOGOUT ===========
const resetSession = (state, action)=>{
  //redireciona pra /
  return updateObject({}, JSON.parse(JSON.stringify(initialState)));
}

const finishLoad = (state, action) => {
  return updateObject(state, {
    session: null,
  });
}

const initLogout = (state, action) => {
  Auth.signOut();
  setTimeout(() => {
    window.location.href="/";
  }, 1000);
  return resetSession(state, initialState);
};

// =========== SESSION ===========
const initSessionActive = (state, action) => {
  if (!!!action.session.attributes) {
    action.session.attributes = action.session.signInUserSession.idToken.payload;
  }

  const session = {
    is_parent_paid: action.isParentPaid,
    is_parent_activity_status: action.isParentActivityStatus,
    plans: action.plans,
    my_user: action.my_user,
    /*     account_type: getUserAccountType(
          action.session.attributes["custom:permissions"]
        ), */
    avatar: action.session.avatar,
    // permissions: action.session.attributes["custom:permissions"],
    permissions: action.plans.permissions,
    parentPermission: action.parentPermission,
    email: action.session.attributes.email,
    email_verified: action.session.attributes.email_verified,
    given_name: action.session.attributes.given_name,
    sub: action.session.attributes.sub,
  };

  const accessToken = action.session.signInUserSession.accessToken.jwtToken;
  const idToken = action.session.signInUserSession.idToken.jwtToken;
  // debugger
  const refreshToken = action.session.signInUserSession.refreshToken.token;
  return updateObject(state, {
    session: session,
    accessToken: accessToken,
    idToken: idToken,
    refreshToken: refreshToken,
  });
};

const initActiveUser = (state, action) => {
  let activeUser = null;
  if (action.activeUser) {
    const {
      avatar = "",
      parent_activity_status = "",
      birth_date = "",
      given_name = "",
      email = "",
      sub = "",
      parent_sub = ""
    } = action.activeUser;
    activeUser = {
      avatar: avatar,
      parent_activity_status: parent_activity_status,
      birth_date: birth_date,
      given_name: given_name,
      sub: sub,
      email: email,
      parent_sub: parent_sub
    };
  }

  return updateObject(state, {
    activeUser: activeUser,
  });
};

const updateMyUser = (state, action) => {
  return updateObject(state, {
    session: {
      ...state.session,
      my_user: {
        ...state.session?.my_user,
        ...action.userData,
      },
    },
  });
};

export default sessionReducer;